/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-phone-input {
  --ux-phone-input-flag-size: 44px;
  display: block;
  position: relative;
}
.ux-phone-input .ux-input {
  border: var(--ux-input-border-width) solid var(--ux-input-border-color);
  flex: 1 1 auto;
  height: var(--ux-input-height);
  padding: var(--ux-input-padding-vertical) var(--ux-input-padding-horizontal);
  padding-left: calc(var(--ux-phone-input-flag-size) + var(--ux-select-icon-size) + var(--ux-input-padding-horizontal));
}
.ux-phone-input .ux-input:hover {
  background-color: var(--ux-input-hover-bg);
  border-color: var(--ux-input-hover-border-color);
}
.ux-phone-input .ux-input:hover:not(:focus) {
  color: var(--ux-input-hover-text-color);
}
.ux-phone-input .ux-input:focus {
  border-color: var(--ux-input-focus-border-color);
  outline: var(--ux-input-focus-border-color) solid var(--ux-input-outline-width);
  outline-offset: var(--ux-input-outline-offset);
}
.ux-phone-input .ux-input:active {
  background-color: var(--ux-input-active-bg);
}
.ux-phone-input ux-country-icon {
  flex: 0 0 auto;
  margin-right: 10px;
}
[dir=rtl] .ux-phone-input ux-country-icon {
  margin-left: 10px;
  margin-right: 0;
}
.ux-phone-input__inner {
  align-items: stretch;
  background-color: var(--ux-input-background-color);
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: stretch;
  position: relative;
}
.ux-phone-input--active .ux-input {
  border-color: var(--ux-input-focus-border-color);
  outline: var(--ux-input-focus-border-color) solid var(--ux-input-outline-width);
  outline-offset: var(--ux-input-outline-offset);
}
.ux-phone-input--disabled .ux-input {
  background-color: var(--ux-input-disabled-bg);
  border-color: var(--ux-input-disabled-border-color);
  color: var(--ux-input-disabled-text-color);
  opacity: var(--ux-input-disabled-opacity);
}
.ux-phone-input--error .ux-input {
  border-color: var(--ux-input-error-border-color);
}
.ux-phone-input--error .ux-input:hover:not(:focus) {
  border-color: var(--ux-input-error-border-color);
}

.ux-phone-input__dropdown-button {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: 0 none transparent;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  justify-content: space-between;
  left: 0;
  margin: 0;
  outline: none;
  padding: 0 10px 0 15px;
  position: absolute;
  top: 0;
}
.ux-phone-input__dropdown-button ux-icon {
  font-size: var(--ux-select-icon-size);
  transition: transform 250ms ease-out;
}
.ux-phone-input--dropdown-opened .ux-phone-input__dropdown-button ux-icon {
  transform: rotate(180deg);
}
.ux-phone-input__dropdown-button--disabled {
  pointer-events: none;
}
.ux-phone-input__dropdown-button--disabled ux-icon,
.ux-phone-input__dropdown-button--disabled ux-country-icon {
  opacity: 0.5;
}

.ux-phone-input__dropdown {
  background-color: var(--ux-input-background-color);
  border: var(--ux-input-border-width) solid var(--ux-input-focus-border-color);
  border-top-width: 0;
  display: none;
  left: 0;
  max-height: 212px;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 100;
}
.ux-phone-input--dropdown-opened .ux-phone-input__dropdown {
  display: block;
}
.ux-phone-input__dropdown > ul {
  list-style: outside none;
  margin: 0;
  padding: 0;
}
.ux-phone-input__dropdown > ul > li {
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 5px 15px;
}
.ux-phone-input__dropdown .ux-phone-input__option.is-active, .ux-phone-input__dropdown .ux-phone-input__option:hover {
  background-color: #eff0f4;
}